import React, { createContext, useEffect, useMemo, useState } from "react";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import EmployeeApp from "./pages/employee";
import CitizenApp from "./pages/citizen";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../../../example/src/theme";
import Home from "./pages/citizen/Home";
import HelloAkash from "./pages/actionView";

export const ColorModeContext = createContext({ toggleThemeMode: () => { } });

export const DigitApp = ({ initData, stateCode, modules, appTenants, logoUrl }) => {
  // console.log('testing deployment on dev')
  const history = useHistory();
  const { pathname, search } = useLocation();
  const [mode, setMode] = useState("light");
  const colorMode = useMemo(
    () => ({
      toggleThemeMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );
  const himachalTheme = useMemo(() => theme(mode), [mode]);
  const innerWidth = window.innerWidth;
  const cityDetails = Digit.ULBService.getCurrentUlb();
  const userDetails = Digit.UserService.getUser();
  const { data: storeData } = Digit.Hooks.useStore.getInitData();
  const { stateInfo } = storeData || {};
  const DSO = Digit.UserService.hasAccess(["FSM_DSO"]);
  let CITIZEN = userDetails?.info?.type === "CITIZEN" || !window.location.pathname.split("/").includes("employee") ? true : false;

  if (window.location.pathname.split("/").includes("employee")) CITIZEN = false;

  useEffect(() => {
    const user = Digit.UserService.getUser();
    const isLoggedIn = user && user.access_token && user.info;
    const getPrefix = (path) => {
      const match = path.match(/^(.*)\/digit-ui/);
      return match ? match[1] : "";
    };
    const isLoginOrLanding = (path) => {
      if (!path) return true;
      const normalized = path.replace(/\/$/, "");
      const prefix = getPrefix(normalized);
      return (
        normalized === `${prefix}/digit-ui` ||
        normalized === `${prefix}/digit-ui/citizen` ||
        normalized === `${prefix}/digit-ui/citizen/login` ||
        normalized === `${prefix}/digit-ui/employee/user/login` ||
        normalized === `${prefix}/digit-ui/employee/user/language-selection` ||
        normalized === `${prefix}/digit-ui/citizen/select-language` ||
        normalized === `${prefix}/digit-ui/citizen/select-location` ||
        normalized.includes("dsc-service") ||
        normalized.includes("process-signed-pdf")
      );
    };

    if (isLoggedIn) {
      if (isLoginOrLanding(pathname)) {
        const lastVisited = sessionStorage.getItem("last_visited_path");
        if (lastVisited && !isLoginOrLanding(lastVisited)) {
          history.replace(lastVisited);
        } else {
          const prefix = getPrefix(pathname);
          const defaultRedirect = user.info.type === "EMPLOYEE"
            ? `${prefix}/digit-ui/employee`
            : `${prefix}/digit-ui/citizen/profile`;
          history.replace(defaultRedirect);
        }
      } else {
        if (!pathname.includes("dsc-service") && !pathname.includes("process-signed-pdf")) {
          sessionStorage.setItem("last_visited_path", pathname + (search || ""));
        }
      }
    }
  }, [pathname, search, history]);

  /* Initializing Localization - Start */
  const [isStateLocalisation, setIsStateLocalisation] = useState(true);
  useEffect(() => {
    if (isStateLocalisation) {
      setIsStateLocalisation(false);
      Digit.LocalizationService.getLocale({
        modules: ["rainmaker-bpa", "rainmaker-bpareg"],
        locale: Digit.StoreData.getCurrentLanguage(),
        tenantId: "up",
      });
    }
  }, []);
  /* Initializing Localization - End */

  useEffect(() => {
    if (!pathname?.includes("application-details")) {
      if (!pathname?.includes("inbox")) {
        Digit.SessionStorage.del("fsm/inbox/searchParams");
      }
      if (pathname?.includes("search")) {
        Digit.SessionStorage.del("fsm/search/searchParams");
      }
    }
    if (!pathname?.includes("dss")) {
      Digit.SessionStorage.del("DSS_FILTERS");
    }
  }, [pathname]);

  useEffect(() => {
    const unlisten = history.listen(() => {
      window?.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    });
    return () => unlisten();
  }, [history]);

  const handleUserDropdownSelection = (option) => {
    option.func();
  };

  const mobileView = innerWidth <= 640;
  let sourceUrl = `${window.location.origin}/citizen`;
  const commonProps = {
    stateInfo,
    userDetails,
    CITIZEN,
    cityDetails,
    mobileView,
    handleUserDropdownSelection,
    logoUrl,
    DSO,
    initData,
    stateCode,
    modules,
    appTenants,
    sourceUrl,
    pathname,
  };

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={himachalTheme}>
        <CssBaseline />

        <Switch>
          <Route path="/digit-ui/employee">
            <EmployeeApp {...commonProps} />
          </Route>
          <Route path="/digit-ui/citizen">
            <CitizenApp {...commonProps} />
          </Route>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/checkStatus">
            <HelloAkash />
          </Route>
          <Route>
            <Redirect to="/digit-ui/citizen" />
          </Route>
        </Switch>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};
